<template>
  <v-container v-if="details !== null">
    <h3 class="secondary--text mt-5">Booking Details</h3>
    <hr class="hor">
    <v-card class="pa-5 mt-5">
      <v-row class="">
        <v-simple-table dense style="width: 100%;">
          <template v-slot:default>
            <thead>
                <tr>
                  <th class="text-left">PNR</th>
                  <th class="text-left">Date</th>
                  <th class="text-left">Time</th>
                  <th class="text-left">Status</th>
                  <th class="text-left">Price</th>
                  <th class="text-left" v-if="details.status.status === 'Initial'">Issuing</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>{{ details.pnr_id }}</td>
                    <td>{{ formatDateTime(details.created_at.substr(0,10)) }}</td>
                    <td>{{ details.created_at.substr(11,5) }}</td>
                    <td>{{ details.status.status }}</td>
                    <td>${{ details.price }}</td>
                </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-row>
    </v-card>

    <h3 class="secondary--text mt-5">Contact Person Details</h3>
    <hr class="hor">
    <v-card class="pa-5 mt-5">
      <v-row class="">
        <v-simple-table dense style="width: 100%;">
          <template v-slot:default>
            <thead>
                <tr>
                    <th class="text-left">Name</th>
                    <th class="text-left">Email</th>
                    <th class="text-left">Phone</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>{{ details.contact_person }}</td>
                    <td>{{ details.contact_email }}</td>
                    <td>{{ details.contact_phone }}</td>
                </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-row>
    </v-card>

    <h3 class="secondary--text mt-5">Passengers Details</h3>
    <hr class="hor">
    <v-card class="pa-5 mt-5">
      <v-row class="">
        <v-simple-table dense style="width: 100%;">
            <template v-slot:default>
              <thead>
                  <tr>
                      <th class="text-left">Name</th>
                      <th class="text-left">Birth Date</th>
                      <th class="text-left">Passport</th>
                      <th class="text-left">Passport Expire Date</th>
                      <th class="text-left">Issue Country</th>
                      <th class="text-left">Ticket</th>
                  </tr>
              </thead>
              <tbody>
                  <tr v-for="passenger in details.passenger_details" :key="passenger.id">
                      <td>{{ passenger.passenger_name }}</td>
                      <td>{{ formatDateTime(passenger.date_of_birth) }}</td>
                      <td v-if="passenger.passport_number">{{ passenger.passport_number }}</td>
                      <td v-else>--</td>
                      <td v-if="passenger.passport_expire_date">{{ formatDateTime(passenger.passport_expire_date) }}</td>
                      <td v-else>--</td>
                      <td v-if="passenger.passport_issue_country">{{ passenger.passport_issue_country }}</td>
                      <td v-else>--</td>
                      <td>{{ passenger.ticket_number ? passenger.ticket_number : 'Not ticketed yet' }}</td>
                      <td class="text-left" v-if="!passenger.passport_number || !passenger.passport_expire_date || !passenger.passport_issue_country">
                      </td>
                  </tr>
              </tbody>
            </template>
        </v-simple-table>
      </v-row>
    </v-card>

    <v-dialog v-model="passportFormDialog">
      <v-card v-if="passengerInfo" class="pa-5">
        <v-snackbar id="snackbar" v-model="snackbar" :color="color" top :timeout="5000">
          <v-row>
            {{ text }}
            <v-spacer></v-spacer>
            <v-btn
              dark
              icon
              @click="snackbar = false"
            >
              <v-icon color="white">mdi-close</v-icon>
            </v-btn>
          </v-row>
        </v-snackbar>
        <v-card-title>Update passport informaton</v-card-title>
        <v-form v-model="validPassport" ref="passportForm">
          <v-text-field
          v-model="passengerInfo.passport_number"
          label="Passport Number"
          prepend-inner-icon="mdi-passport"
          outlined
          :rules="[
            v => !!v || 'Passport number is required',
            v => v && v.length <= 15 || 'Maximum number of characters is 15',
            v => v && v.length >= 5 || 'Minimum number of characters is 5'
          ]"
          persistent-hint
          color="blue"
          id="passenger-passport-num"
          ></v-text-field>

          <date-picker
          v-model="passengerInfo.passport_expire_date"
          clearable
          editable
          valueType="YYYY-MM-DD"
          placeholder="Passport Expire Date:Optional"
          :default-value="passportMinExpireDate"
          style="width: 100%; height: 56px !important;"
          :disabled-date="minExpireDateRange"
          format="M/D/YYYY"
          hint="MM/DD/YYYY'"
          append-to-body
          :input-attr="{id: 'passportExpiry'}"
          @focus="changeInputColor('passportExpiry', '#2196F3')"
          @blur="changeInputColor('passportExpiry', '#9e9e9e')"
          @input-error="changeInputColor('passportExpiry', 'red')"
          id="passenger-passportExpiry"
          >
          </date-picker>
          <span class="caption grey--text">Hint: MM/DD/YYYY</span>

          <v-autocomplete
          v-model="passengerInfo.passport_issue_country"
          :items="countries"
          item-text="name"
          item-value="code"
          placeholder="Issuing Country:Optioanl"
          persistent-hint
          name="issue-country-for-passports"
          required
          outlined
          prepend-inner-icon="mdi-flag"
          hide-no-data
          color="blue"
          autocomplete="off"
          :menu-props="{ auto: true, maxWidth: 200, overflowY: true }"
          id="passenger-passport-issue-country"
          :rules="[v => !!v || 'This field is required']"
          ></v-autocomplete>
        </v-form>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blueDark" dark large tile elevation="0" @click="savePassengerPassportInfo" :loading="saveLoad">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog  max-width="500" v-model="issueRequestDialog">
      <v-card max-width="500" v-if="user.subAgent" class="pa-5">
        <v-snackbar id="snackbar" v-model="snackbar" :color="color" top :timeout="5000">
          <v-row>
            {{ text }}
            <v-spacer></v-spacer>
            <v-btn
              dark
              icon
              @click="snackbar = false"
            >
              <v-icon color="white">mdi-close</v-icon>
            </v-btn>
          </v-row>
        </v-snackbar>
        <v-card-title class="px-0">Request Issue</v-card-title>
        <v-select :items="user.subAgent.agents_emails" class="mb-5" hide-details v-model="selectedEmail" outlined label="Choose agent to issue"></v-select>
        <v-text-field v-model="emailToAdd" :rules="[v => (/^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/.test(v) || v === '') || 'E-mail must be valid']" outlined label="Add Email" hint="Add email to emails list" persistent-hint append-icon="mdi-plus-circle" @click:append="addEmail"  @keyup.enter="addEmail"></v-text-field>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn tile elevation="0" color="blueDark white--text" :disabled="!selectedEmail" @click="requestIssue" :loading="loadRequestBtn">Request</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <h3 class="secondary--text mt-5">Flight Segments</h3>
    <hr class="hor">
    <v-row class="" v-for="(segment, i) in details.flight_segments" :key="segment.id">
      <v-card class="px-5 ma-3 mt-5" width="100%">
        <h3 class="secondary--text my-2">Segment {{i + 1}}</h3>
        <v-simple-table dense style="width: 100%;">
          <template v-slot:default>
            <thead>
                <tr>
                    <th class="text-left">Airline</th>
                    <th class="text-left">Flight NO.</th>
                    <th class="text-left">Duration</th>
                    <th class="text-left">From</th>
                    <th class="text-left">To</th>
                    <th class="text-left">Status</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>{{ segment.airline }}</td>
                    <td>{{ segment.flight_number }}</td>
                    <td>{{ segment.flight_duration }}h</td>
                    <td>
                      {{ segment.departure_location }}
                      <br>
                      {{formatDateTime(segment.departure_date)}}, {{segment.departure_time}}
                    </td>
                    <td>
                      {{ segment.arrival_location }}
                      <br>
                      {{formatDateTime(segment.arrival_date)}}, {{segment.arrival_time}}
                    </td>
                    <td>
                      {{segment.status.name}}
                    </td>
                </tr>
            </tbody>
          </template>
        </v-simple-table>
        </v-card>
    </v-row>
  </v-container>
</template>

<script>
import { countries } from '../contants'
import { headersAuth, cancelFlight, updatePassportInfo } from '../links'
import { mapState } from 'vuex'

export default {
  props: ['details'],
  components: {
  },
  data () {
    return {
      passengerInfo: null,
      passportFormDialog: false,
      validPassport: true,
      saveLoad: false,
      saveCardLoad: false,
      validPayment: true,
      snackbar: false,
      mainSnackbar: false,
      color: '',
      text: '',
      loadCancelBtn: false,
      loadRequestBtn: false,
      issueRequestDialog: false,
      selectedEmail: '',
      emailToAdd: ''
    }
  },
  computed: {
    countries () {
      return countries
    },
    ...mapState(['user'])
  },
  methods: {
    formatDateTime (date) {
      const [year, month, day] = date.split('-')
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      return `${day} ${months[month - 1]} ${year}`
    },
    openPassportForm (passenger) {
      this.passengerInfo = JSON.parse(JSON.stringify(passenger))
      this.passportFormDialog = true
    },
    passportMinExpireDate () {
      const lastFlightSegment = this.details.flight_segments[this.details.flight_segments.length - 1]
      console.log(lastFlightSegment)
      const lastArrivalDate = lastFlightSegment.arrival_date
      const today = new Date(lastArrivalDate)
      today.setMonth(today.getMonth() + 6)
      return today
    },
    minExpireDateRange (date) {
      return date < new Date(this.passportMinExpireDate())
    },
    changeInputColor (id, color) {
      document.getElementById(id).style.borderColor = color
    },
    savePassengerPassportInfo () {
      this.$refs.passportForm.validate()
      if (this.validPassport && this.passengerInfo.passport_expire_date) {
        this.saveLoad = true
        const body = {
          reference_number: this.details.booking_reference,
          passenger_details: [this.passengerInfo]
        }
        const token = localStorage.getItem('BVtoken')
        const header = { headers: headersAuth(token) }
        this.$http.post(updatePassportInfo, body, header).then(response => {
          if (response.data.status) {
            this.details.passenger_details[this.details.passenger_details.findIndex(el => el.id === this.passengerInfo.id)].passport_number = this.passengerInfo.passport_number
            this.details.passenger_details[this.details.passenger_details.findIndex(el => el.id === this.passengerInfo.id)].passport_issue_country = this.passengerInfo.passport_issue_country
            this.details.passenger_details[this.details.passenger_details.findIndex(el => el.id === this.passengerInfo.id)].passport_expire_date = this.passengerInfo.passport_expire_date
            this.snackbar = true
            this.color = 'success'
            this.text = 'Passport information updated successfully'
          } else {
            this.snackbar = true
            this.color = 'error'
            this.text = response.data.message
          }
        }).catch(err => {
          this.snackbar = true
          this.color = 'error'
          this.text = err.data.message
        }).finally(() => {
          this.saveLoad = false
          this.passportFormDialog = false
          this.$refs.passportForm.reset()
        })
      } else {
        this.snackbar = true
        this.color = 'warning'
        this.text = 'Please fill all fields'
      }
    },
    cancelFlight () {
      const token = localStorage.getItem('BVtoken')
      const header = { headers: headersAuth(token) }
      this.loadCancelBtn = true
      this.$http.post(cancelFlight, { pnr: this.details.pnr_id }, header).then(response => {
        if (response.body.status) {
          this.mainSnackbar = true
          this.color = 'success'
          this.text = 'Flight cancelled'
          this.details.status.status = 'Cancelled'
        } else {
          this.mainSnackbar = true
          this.color = 'error'
          this.text = response.body.message
        }
      }).catch(err => {
        this.disableCancelBtn = false
        this.mainSnackbar = true
        this.color = 'error'
        this.text = err.body.message
      }).finally(() => {
        this.loadCancelBtn = false
      })
    }
  }
}
</script>

<style>
  .hor {
    border: none;
    height: 2px;
    width: 169px;
    background-color: #DF731C;
    margin: 15px 0;
  }
  .mx-input {
    width: 100%;
    height: 56px !important;
    border-color: #9e9e9e;
    margin-bottom: 20px !important;
  }
</style>
